/**
* Created by Jaime Bonilla Venegas on 2017-06-13.
* Item model for each "Conceptos"
*/
import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Trash from 'material-ui/svg-icons/action/delete';
import Edit from 'material-ui/svg-icons/content/create';
import Block from 'material-ui/svg-icons/content/block';
import Guardar from 'material-ui/svg-icons/content/save';
import { EditableInline, EditableInlineV2 } from '../../../components/text';
import IconButton from 'material-ui/IconButton';
import Avatar from 'material-ui/Avatar';
import ListItem from 'material-ui/List/ListItem';
import Toggle from 'material-ui/Toggle';
import { setValueIn } from '../../../common/immutable';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { buildErrorsState, validateField, errorsEmpty } from '../../../validations';

const errorsProps = {
    name: [],
    email: [],
    role: []
};

//Each rule might correspond with the key for the field to validate
//For now I only use comertialInvoiceNumber
const rules = {
    name: [{ key: 'required', errorText: 'Campo requerido' }],
    email: [
        { key: 'required', errorText: 'Campo requerido' },
        { key: 'validationEmail', errorText: 'Ingrese un correo valido' }
    ]
};

const styles = {
    toggle: {
        marginBottom: 0,
    },
};

class Item extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            user: props.user,
            errors: { ...errorsProps },
        };
    }

    updateUser(path, value, path2) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path2, value)
        );
        const user = setValueIn(parsePath(path), value, this.state.user);
        this.setState({ user, errors });
    }

    renderButtons(editing, user, onSave) {
        const { allowUpdate, allowDelete } = this.props;

        return (
            <div className="space-around">
                {
                    editing && <IconButton
                        tooltip="Cancelar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => this.setState({ editing: false, user, errors: errorsProps })}
                    >
                        <Block />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    editing && <IconButton
                        tooltip="Guardar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (errorsEmpty(this.state.errors)) {
                                this.setState({ editing: false });
                                onSave(this.state);
                            }
                        }}
                    >
                        <Guardar />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowUpdate) && <IconButton
                        tooltip="Editar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            this.setState({ user: user });
                            this.setState({ editing: true });
                            this.setState({ user: user })
                        }}
                    >
                        <Edit />
                    </IconButton>
                }
            </div>
        );
    }

    handleToggle() {
        this.updateUser('active', !this.state.user.active, 'active')
    }

    render() {

        const { editing, errors } = this.state;
        const { onSave, user } = this.props;
        const currentProperties = editing ? this.state.user : user;
        const { name, email, active, password, role, roster } = currentProperties;

        var image = new Image();
        image.src = roster;

        return (
            <div>
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 pl0">
                    <div className="main-card item-row">
                        <div className="col-lg-6 col-md-7 col-sm-6 col-xs-12 card-buttons hidden-md-down" style={{ minHeight: '3.6rem' }}>

                        </div>
                        <div className="col-lg-6 col-md-5 col-sm-6 col-xs-12 card-buttons hidden-md-down" style={{ minHeight: '3.6rem', paddingTop: '0.8rem' }}>
                            <div className="space-around">
                                {this.renderButtons(editing, user, onSave)}
                            </div>
                        </div>
                        <div className="col-xs-12 white-card box-shadow padding-2 vcenter">
                            <div className="col-lg-3 col-md-2 col-sm-3 col-xs-3 no-paddings">
                                <ListItem
                                    className="avatar-gestion-usuarios"
                                    disabled={true}
                                    leftAvatar={
                                        <Avatar src={roster === '' ? "images/uxceo-128.jpg" : image.src} />
                                    }
                                >
                                </ListItem>
                                {/*<h5 className="text-center">{name}</h5>*/}
                            </div>
                            <div className="col-lg-9 col-md-10 col-sm-9 col-xs-9">
                                <div className="row">
                                    <div className="col-md-12">
                                        <EditableInlineV2
                                            type="text"
                                            label='Nombre Usuario'
                                            editViewActive={editing}
                                            value={name}
                                            notify={(value) => this.updateUser('name', value, 'name')}
                                            errorText={errors.name.join(' | ')}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <EditableInlineV2
                                            type="text"
                                            label='Correo electronico'
                                            editViewActive={editing}
                                            value={email}
                                            notify={(value) => this.updateUser('email', value, 'email')}
                                            errorText={errors.email.join(' | ')}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <EditableInlineV2
                                            type="autocomplete"
                                            value={getValueFromSelectList([
                                              { id: 'ROLE_ADMIN', name: 'Administrador' },
                                              { id: 'ROLE_EXECUTIVE', name: 'Ejecutivo' },
                                              { id: 'ROLE_OPERATIVE', name: 'Operativo' },
                                              { id: 'ROLE_DOCUMENT_SUPPORTER', name: 'Documentador' },
                                              { id: 'ROLE_FINANCES', name: 'Finanzas' }
                                            ], role).name}
                                            label="Rol"
                                            editViewActive={editing}
                                            items={[
                                              { id: 'ROLE_ADMIN', name: 'Administrador' },
                                              { id: 'ROLE_EXECUTIVE', name: 'Ejecutivo' },
                                              { id: 'ROLE_OPERATIVE', name: 'Operativo' },
                                              { id: 'ROLE_DOCUMENT_SUPPORTER', name: 'Documentador' },
                                              { id: 'ROLE_FINANCES', name: 'Finanzas' }
                                            ]}
                                            notify={(value) => this.updateUser('role', value.id, 'role')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <div className="col-xs-12 border-top pt1 pl0 pr0 margin-top-1">
                                <div className="col-xs-6 no-paddings toggle-style">
                                    <Toggle
                                        label={active === true ? "Activo" : "Inactivo"}
                                        disabled={!editing}
                                        style={styles.toggle}
                                        onToggle={this.handleToggle.bind(this)}
                                        defaultToggled={active}
                                    />
                                </div>
                                <div className="col-xs-6 pr0">
                                    {/* <FlatButton label="Revocar Sesion" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-5 col-sm-5 col-md-3 pull-right card-buttons margin-bottom-2 hidden-lg-up"
                            style={{ minHeight: '3.6rem', paddingTop: '0.8rem' }}>
                            <div className="space-around">
                                {this.renderButtons(editing, user, onSave)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Item;



// WEBPACK FOOTER //
// ./containers/users/components/item.js